import type { SwitchProps } from '@sravni/react-design-system/lib/Switch';
import { Switch as DesignSystemSwitch } from '@sravni/react-design-system/lib/Switch';
import cn from 'classnames';
import { forwardRef } from 'react';

import styles from './Switch.module.scss';

export const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
  const { className, ...otherProps } = props;
  return (
    <DesignSystemSwitch
      {...otherProps}
      ref={ref}
      className={cn(styles.switch, className)}
    />
  );
});
